import { TaxonomyIdItem } from "@amzn/taxonomy-lib";
import { PreCheckoutInformation } from "common/types";
import { CatalogicalItem, CatalogicalRequestContent } from "common/types/catalogical-type";
import { CatalogicalService, IOrdersService, OrdersServiceFactory } from "lib/services";
import { FilteringOptions, GetItemResponsePagination } from "lib/services/catalogical-models";
import { ItemTaxonomyId } from "lib/taxonomy/item-taxonomy-id";
import { useState } from "react";

const client = new CatalogicalService<CatalogicalItem>("itsoftware");

export interface GetItemsProps {
  searchParams: CatalogicalRequestContent;
}

export function useGetItems() {
  const [items, setItems] = useState<CatalogicalItem[] | undefined>(undefined);
  const [paginationInfo, setPaginationInfo] = useState<GetItemResponsePagination>({ total: 0, offset: 0, limit: 0 });
  const [error, setError] = useState<Error | undefined>(undefined);
  const [isLoading, setLoading] = useState<boolean>(false);

  async function doGetItems(props: GetItemsProps) {
    setLoading(true);

    try {
      const response = await client.getCatalogicalItems(props.searchParams);
      if (!response) {
        const err = { name: "No response", message: "No response getting the items" };
        setError(err);
        setLoading(false);
        return undefined;
      }
      setError(undefined);
      setPaginationInfo(response.pagination);
      setItems(response.data);
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(err as Error);
    }
    setLoading(false);
    return undefined;
  }

  return { items, paginationInfo, error, isLoading, doGetItems };
}

export function useGetItem() {
  const [item, setItem] = useState<CatalogicalItem | undefined>(undefined);
  const [error, setError] = useState<Error | undefined>(undefined);
  const [isLoading, setLoading] = useState<boolean>(false);

  async function doGetItem(taxonomyId: string) {
    setLoading(true);

    try {
      const response = await client.getCatalogItemByTaxonomyId(new TaxonomyIdItem(taxonomyId));
      if (!response) {
        const err = { name: "No response", message: "No response getting the item" };
        setError(err);
        setLoading(false);
        return undefined;
      }
      setError(undefined);
      setItem(response.item);
      setLoading(false);
      return response.item;
    } catch (err) {
      setError(err as Error);
    }
    setLoading(false);
  }

  return { item, error, isLoading, doGetItem };
}
